import React from 'react';

function Labels({ labels = [], onDelete }) {
  console.log("Labels received:", labels);
  if (!labels.length) {
    return <div>No labels found.</div>;
  }

  return (
    <div className="space-y-4">
      {labels.map((label) => (
        <div
          key={label._id}
          className="flex flex-col md:flex-row items-start bg-white rounded-xl shadow-md border border-gray-200 p-4 gap-4"
        >
         
         {/* Text content */}
<div className="flex-1">
  <h2 className="text-xl font-semibold mb-1 text-gray-800">
    {label.name || 'Unnamed Label'}
  </h2>
  <p className="text-gray-600 mb-2">
    <span className="font-medium">Description:</span>{' '}
    {label.description || 'No description provided.'}
  </p>
  <div className="flex items-center gap-2">
    <span className="text-sm font-medium text-gray-600">Color:</span>
    <div
      className="w-6 h-6 rounded-full border"
      style={{ backgroundColor: label.color }}
      title={label.color}
    ></div>
    <span className="text-sm text-gray-500">{label.color}</span>
  </div>
</div>


          {/* Actions */}
          <div className="flex flex-col gap-2 mt-4 md:mt-0 md:ml-auto">
            <button
              onClick={() => {
                if (window.confirm("Are you sure you want to delete this label?")) {
                  onDelete && onDelete(label._id);
                }
              }}
              className="bg-red-500 hover:bg-red-600 text-white px-4 py-2 rounded text-sm"
            >
              Delete
            </button>
          </div>
        </div>
      ))}
    </div>
  );
}

export default Labels;
